import { Link } from "react-router-dom";
import "../css/pagination.css";

const Pagination = ({
  page,
  perPage,
  totalRecords,
  totalPages,
  records,
  prevButton,
  nextButton,
}) => {
  return (
    <div className="card-body p-1">
      <div className="row">
        <div className="col-lg-12">
          <nav>
            <ul className="pagination-custom">
              <li
                className={`pagination-item prev ${
                  page <= 1 ? "disabled" : ""
                } ${page > 1 ? "active" : ""}`}
                onClick={prevButton}
              >
                <Link className="page-link" to="#">
                  <i className="fas fa-chevron-left"></i>
                </Link>
              </li>
              <li className={`pagination-item page-number`}>
                <Link className="page-link" to="#">
                  {page}
                </Link>
              </li>
              <li
                className={`pagination-item next ${
                  totalPages === page ? "disabled" : ""
                } ${totalPages > page ? "active" : ""}`}
                onClick={nextButton}
              >
                <Link className="page-link" to="#">
                  <i className="fas fa-chevron-right"></i>
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
